// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
messaging .box {
  background-color: var(--c_backgroundBox);
  border-radius: 4px;
  margin-top: 2px;
}
messaging .box:first-child {
  margin-top: 0px;
}
messaging .header {
  padding: 20px 20px;
}
messaging .header .columnWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
}
messaging .header .columnWrapper .column {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
}
messaging .header .columnWrapper .column .item {
  padding: 0 4%;
  box-sizing: border-box;
  line-height: 1.1em;
}
messaging .header .columnWrapper .column .item.paymentInfo {
  padding-right: 0;
}
messaging .header .columnWrapper .column .icon {
  text-align: center;
}
messaging .header .columnWrapper .column .icon visiba-svg {
  width: 20px;
  margin-top: 14px;
}
messaging .header .columnWrapper .column .icon + div {
  width: calc(100% - 30px);
  margin-left: 10px;
}
messaging .header .columnWrapper .column .title {
  font-weight: normal;
  font-size: 0.75em;
}
messaging .header .columnWrapper .column .info {
  font-weight: lighter;
}
messaging .messageAreaWrapper {
  padding-right: 2px;
}
messaging .resourceArea {
  align-items: center;
}
messaging .resourceArea .name {
  font-size: 1.375em;
}
messaging .resourceArea visiba-svg {
  height: 40px;
  width: 40px;
}
messaging .resourceArea .resourceInfo {
  margin-left: 20px;
}
messaging .resourceArea .resourceInfo p {
  overflow: hidden;
  margin: 0px;
  white-space: nowrap;
}
messaging .forms {
  margin-top: 20px;
}
messaging .forms .form {
  display: inline-block;
  cursor: pointer;
}
messaging .forms .form .icon {
  display: inline-block;
  position: relative;
}
messaging .forms .form .icon visiba-svg {
  width: 20px;
  position: relative;
  margin-top: 3px;
}
messaging .forms .form .icon span {
  position: absolute;
  border-radius: 100%;
  height: 17px;
  width: 17px;
  background-color: var(--c_accentColor);
  border: solid 2px #fff;
  font-weight: bold;
  top: -4px;
  right: -7px;
  box-sizing: border-box;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  line-height: 13px;
  font-size: 0.8125em;
}
messaging .forms .form .formInfo {
  float: right;
  margin-left: 12px;
}
messaging .forms .form .formName {
  line-height: 1em;
  font-size: 1.25em;
}
messaging .forms .form .notice {
  line-height: 1em;
  color: var(--c_accentColor);
}
messaging .messageArea {
  max-height: 480px;
  overflow: auto;
  position: relative;
}
messaging .messageArea .loader {
  text-align: center;
  position: absolute;
  top: calc(50% - 20px);
  width: 100%;
}
messaging .messageArea .loader visiba-svg {
  width: 40px;
}
messaging .messageArea .messagesWrapper {
  padding: var(--m_components);
}
@keyframes fadeInMessage {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
messaging .messageArea .messagesWrapper > .line:first-child {
  border-top: none;
  padding-top: 0px;
  margin-top: 0px;
}
messaging .messageArea .messagesWrapper .line {
  border-top: solid 1px rgba(var(--c_textBody), 0.25);
  padding-top: var(--m_elements);
  margin-top: var(--m_elements);
}
messaging .messageArea .messagesWrapper .messageHeader {
  text-align: center;
  font-size: 0.75em;
  font-weight: 400;
}
messaging .messageArea .messagesWrapper .messageAndHeader .messageInfo {
  display: flex;
  align-items: center;
}
messaging .messageArea .messagesWrapper .messageAndHeader .messageInfo .profileImg {
  width: 40px;
  height: 40px;
  float: left;
  display: inline-block;
  line-height: 0;
}
messaging .messageArea .messagesWrapper .messageAndHeader .messageInfo .profileImg img {
  width: 100%;
  border-radius: 100%;
  height: 40px;
}
messaging .messageArea .messagesWrapper .messageAndHeader .messageInfo .profileImg visiba-svg {
  width: 100%;
}
messaging .messageArea .messagesWrapper .messageAndHeader .messageInfo .info {
  float: left;
  width: calc(100% - 40px);
  padding-left: 25px;
  box-sizing: border-box;
  line-height: 1.2em;
}
messaging .messageArea .messagesWrapper .messageAndHeader .messageInfo .info .other {
  font-weight: lighter;
}
messaging .messageArea .messagesWrapper .message {
  margin-top: 10px;
  line-height: 1.35em;
  box-sizing: border-box;
  padding-left: 66px;
}
messaging .messageArea .messagesWrapper .message pre {
  font-size: 1em;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 1.35em;
  margin: 0;
}
messaging .messageArea .messagesWrapper .message .timestamp {
  font-weight: lighter;
  font-size: 0.875em;
  margin-top: 20px;
}
messaging .messageArea .messagesWrapper .message .redRobinSession {
  color: #777;
}
messaging .messageArea .messagesWrapper .formsInConversation .form {
  cursor: pointer;
  margin-top: 10px;
  padding-left: 66px;
  max-width: 50%;
}
messaging .messageArea .messagesWrapper .formsInConversation .form .icon {
  float: left;
  width: 40px;
}
messaging .messageArea .messagesWrapper .formsInConversation .form .icon visiba-svg {
  width: 100%;
}
messaging .messageArea .messagesWrapper .formsInConversation .form .text {
  float: left;
  width: calc(100% - 50px);
  margin-left: 10px;
  line-height: 1.2em;
}
messaging .messageArea .messagesWrapper .formsInConversation .form .text .--unanswered {
  color: var(--c_errorText);
}
messaging .messageArea .messagesWrapper .formsInConversation .form .text .--answered {
  color: var(--c_textLink);
}
messaging .messageArea .messagesWrapper .files .file {
  max-width: 50%;
}
messaging .messageArea .messagesWrapper .files .file .nonImage {
  padding-top: 10px;
}
messaging .messageArea .messagesWrapper .files .file .nonImage .icon {
  width: 40px;
}
messaging .messageArea .messagesWrapper .files .file .nonImage .icon visiba-svg {
  width: 100%;
}
messaging .messageArea .messagesWrapper .files .file .nonImage .text {
  padding-top: 10px;
  width: calc(100% - 50px);
  margin-left: 10px;
  line-height: 1.2em;
}
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .icon {
  position: relative;
}
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .icon visiba-svg,
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .icon svg {
  display: block;
}
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .icon visiba-svg {
  stroke-dasharray: 250;
  stroke-dashoffset: 250;
  transition: all 0.1s ease-out;
}
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .icon span {
  position: absolute;
  top: 22%;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 0.75em;
}
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .icon.failed .fill {
  fill: var(--c_accentColor);
}
messaging .messageArea .messagesWrapper .files .file .nonImage.uploading .text {
  padding-top: 0;
}
messaging .messageArea .messagesWrapper .files .file img {
  max-height: 150px;
  cursor: pointer;
  float: left;
}
messaging .messageArea .messagesWrapper .caseClosed {
  text-align: center;
  padding-top: var(--m_elements);
  font-size: 0.75em;
}
messaging .messageArea .messagesWrapper .caseClosed > div {
  line-height: 15px;
}
messaging .messageArea .messagesWrapper .caseClosed span {
  font-weight: 600;
}
messaging .messageArea .messagesWrapper .newMessage {
  display: none;
  text-align: center;
  font-size: 0.75em;
  margin-top: -2px;
  margin-bottom: -5px;
}
messaging .messageArea .messagesWrapper .unread {
  border-top: 2px solid var(--c_mainColorLight);
  margin-top: 15px;
}
messaging .messageArea .messagesWrapper .unread .newMessage {
  display: block;
}
messaging .messageArea .messagesWrapper .unread .newMessage + .messageAndHeader {
  margin-top: -24px;
}
messaging .messageArea .messagesWrapper .unread ~ .unread {
  margin-top: 0;
  border-top: none;
}
messaging .messageArea .messagesWrapper .unread ~ .unread .newMessage {
  display: none;
}
messaging .messageArea .messagesWrapper .unread ~ .unread .newMessage + .messageAndHeader {
  margin-top: unset;
}
messaging .reconectInfo {
  background-color: var(--c_buttonDisabledText);
  margin-top: 2px;
  margin-bottom: -2px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 5px 20px;
}
messaging .reconectInfo + .writingArea::before {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
messaging .writingArea {
  display: inline-block;
  position: relative;
  width: 100%;
  margin-top: 2px;
}
messaging .writingArea::before {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: var(--c_backgroundBox);
  z-index: 0;
  border-radius: 4px;
  content: "";
  transition: left 0.2s ease-in-out, right 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
messaging .writingArea > * {
  position: relative;
  z-index: 1;
}
messaging .writingArea.focus:not(.disabled)::before {
  left: -6px;
  right: -6px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
}
messaging .writingArea.disabled {
  opacity: 0.5;
}
messaging .writingArea.disabled visiba-svg svg .fill {
  fill: var(--c_buttonDisabledText);
}
messaging .writingArea.disabled .content .send {
  cursor: default;
}
messaging .writingArea .content {
  padding: 12px 20px;
  display: flex;
  align-items: center;
}
messaging .writingArea .content .plus {
  position: relative;
  float: left;
  width: 20px;
  height: 20px;
  line-height: 0;
  overflow: hidden;
  cursor: pointer;
}
messaging .writingArea .content .plus input {
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}
messaging .writingArea .content .plus visiba-svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 2;
}
messaging .writingArea .content .plus visiba-svg svg {
  width: 100%;
  height: 100%;
}
messaging .writingArea .content .plus input:hover + svg polygon {
  fill: var(--c_mainColorDarkActive);
}
messaging .writingArea .content .input {
  float: left;
  width: calc(100% - 20px);
  padding: 0 20px;
  box-sizing: border-box;
}
messaging .writingArea .content .input visiba-input .wallInput.wallStyling {
  padding: 0px;
  margin: 0;
}
messaging .writingArea .content .input visiba-input .wallInput.wallStyling::before {
  content: none;
}
messaging .writingArea .content .input visiba-input .wallInput.wallStyling::after {
  content: none;
}
messaging .writingArea .content .input visiba-input .wallInput.wallStyling textarea {
  border: none;
  padding: 0px;
  box-sizing: border-box;
  padding-top: 3px;
}
messaging .writingArea .content .input visiba-input .wallInput.wallStyling label {
  display: none;
}
messaging .writingArea .content .send {
  float: left;
  width: 20px;
  line-height: 0;
  cursor: pointer;
}
messaging .writingArea .content .send visiba-svg {
  width: 20px;
}
messaging .footer {
  text-align: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
